// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ct-no-cookie-page[data-v-f489a23c]{padding:60px 0 80px}@media(min-width:768px){.ct-no-cookie-page[data-v-f489a23c]{padding:80px 0 120px}}.header-logo-container[data-v-f489a23c]{background-color:#bed7aa;padding-top:40px}.header-logo[data-v-f489a23c] svg{display:block;height:1.5rem;width:auto}@media(min-width:768px){.header-logo[data-v-f489a23c] svg{height:2rem}}@media(min-width:1920px){.header-logo[data-v-f489a23c] svg{height:40px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
